// Guard de ruta: las pantallas de FABRICACIÓN no son para quien sólo compra y
// vende. Teclear /gantt no debe enseñar una pantalla vacía que parece rota.
//
// Usa la misma query ['auth-me'] que useSinProduccion y espera a que resuelva:
// redirigir durante la carga expulsaría a un usuario legítimo que recarga.
import { useQuery } from '@tanstack/react-query'
import { Navigate, Outlet } from 'react-router-dom'
import { authApi } from '@/services/api'

export function RequireProduccion() {
  const { data, isLoading } = useQuery({
    queryKey: ['auth-me'],
    queryFn: authApi.getMe,
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    retry: false,
  })
  if (isLoading) return null
  if (data?.sinProduccion) return <Navigate to="/home" replace />
  return <Outlet />
}
